import { getCookie } from 'shared/lib/cookieMethods';

import { readClientIdFromCookie, readYandexClientIdFromCookieOrScript } from './readUtmId';

export const getAnalyticsIds = (isWl: boolean) => {
  const uaClientId = readClientIdFromCookie(getCookie);
  const ymClientId = readYandexClientIdFromCookieOrScript(getCookie, isWl);

  return {
    uaClientId,
    ymClientId,
  };
};
